import { createContext, useContext } from 'react';

/**
 * Toast context and hook, split from <ToastProvider> so that the provider file
 * exports only components (and stays eligible for React Fast Refresh).
 */

export interface ToastApi {
  /** Confirms a completed action. Past tense, same verb as the trigger. */
  ok: (message: string, detail?: string) => void;
  /** Reports a failure: what happened, and what to do about it. */
  error: (message: string, detail?: string) => void;
  info: (message: string, detail?: string) => void;
}

export const ToastContext = createContext<ToastApi | null>(null);

export function useToast(): ToastApi {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error('useToast must be used inside <ToastProvider>');
  return ctx;
}
